class DateFactory {
  private static readonly locale = localStorage.getItem('locale') || 'tr-TR';

  public static now(): Date {
    return new Date();
  }

  public static today(): Date {
    return new Date(new Date().setHours(0, 0, 0, 0));
  }

  public static yesterday(): Date {
    return new Date(new Date().setDate(new Date().getDate() - 1));
  }

  //Before

  public static lastWeek(): Date {
    return new Date(new Date().setDate(new Date().getDate() - 7));
  }

  public static lastMonth(): Date {
    return new Date(new Date().setMonth(new Date().getMonth() - 1));
  }

  public static lastYear(): Date {
    return new Date(new Date().setFullYear(new Date().getFullYear() - 1));
  }

  public static lastHour(): Date {
    return new Date(new Date().setHours(new Date().getHours() - 1));
  }

  public static last15min(): Date {
    return new Date(new Date().setMinutes(new Date().getMinutes() - 15));
  }

  public static last30min(): Date {
    return new Date(new Date().setMinutes(new Date().getMinutes() - 30));
  }

  public static last6Hour(): Date {
    return new Date(new Date().setHours(new Date().getHours() - 6));
  }

  public static last12Hour(): Date {
    return new Date(new Date().setHours(new Date().getHours() - 12));
  }

  public static last1day(): Date {
    return new Date(new Date().setDate(new Date().getDate() - 1));
  }

  public static last7day(): Date {
    return new Date(new Date().setDate(new Date().getDate() - 7));
  }

  public static last15day(): Date {
    return new Date(new Date().setDate(new Date().getDate() - 15));
  }

  public static last30day(): Date {
    return new Date(new Date().setDate(new Date().getDate() - 30));
  }

  public static last90day(): Date {
    return new Date(new Date().setDate(new Date().getDate() - 90));
  }

  public static last180day(): Date {
    return new Date(new Date().setDate(new Date().getDate() - 180));
  }

  public static last365day(): Date {
    return new Date(new Date().setDate(new Date().getDate() - 365));
  }

  public static toConvertLocalDateString(date: Date): string {
    return date.toLocaleDateString(DateFactory.locale);
  }

  //After

  public static tomorrow(): Date {
    return new Date(new Date().setDate(new Date().getDate() + 1));
  }

  public static afterWeek(): Date {
    return new Date(new Date().setDate(new Date().getDate() + 7));
  }

  public static afterMonth(): Date {
    return new Date(new Date().setMonth(new Date().getMonth() + 1));
  }

  public static afterYear(): Date {
    return new Date(new Date().setFullYear(new Date().getFullYear() + 1));
  }

  public static afterHour(): Date {
    return new Date(new Date().setHours(new Date().getHours() + 1));
  }

  public static after15min(): Date {
    return new Date(new Date().setMinutes(new Date().getMinutes() + 15));
  }

  public static after30min(): Date {
    return new Date(new Date().setMinutes(new Date().getMinutes() + 30));
  }

  public static after7day(): Date {
    return new Date(new Date().setDate(new Date().getDate() + 7));
  }

  public static after30day(): Date {
    return new Date(new Date().setDate(new Date().getDate() + 30));
  }

  public static after90day(): Date {
    return new Date(new Date().setDate(new Date().getDate() + 90));
  }

  public static after180day(): Date {
    return new Date(new Date().setDate(new Date().getDate() + 180));
  }

  public static after365day(): Date {
    return new Date(new Date().setDate(new Date().getDate() + 365));
  }
}

export default DateFactory;
